export default {
  path: '/orderForm',
  name: 'orderForm',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/orderForm/forms',
  children: [
    {
      path: 'forms',
      meta: { title: '订购表单' },
      component: () => import('@/views/orderForm/forms/index'),
    },
    {
      path: 'forms/:id',
      meta: { title: '表单配置' },
      component: () => import('@/views/orderForm/forms/detail'),
    },
    {
      path: 'orders',
      meta: { title: '订购订单' },
      component: () => import('@/views/orderForm/orders/index'),
    },
  ],
}
